import React from 'react';
import { NotificationsDropdown } from '../components/notificationsDropdown/NotificationsDropdown';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { SettingsDropdown } from '../components/settingsDropdown/SettingsDropdown';
import { HeaderFullscreen } from '../components/HeaderFullscreen/HeaderFullscreen';
import * as S from '../Header.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { useHeader } from './HeaderContext';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';

interface DesktopHeaderProps {
  isTwoColumnsLayout: boolean;
  moduleName: string;
  breadcrumb: React.ReactNode;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ isTwoColumnsLayout, moduleName, breadcrumb }) => {
  const { headerButtons } = useHeader();

  return (
    <>
      <BaseRow justify="end" align="middle" style={{ marginBottom: '0px', marginTop: '0px', height: '30px' }}>
        {/* <S.ProfileColumn xl={24} xxl={24} $isTwoColumnsLayout={isTwoColumnsLayout}>
          <BaseRow align="middle" justify="end" gutter={[8, 8]}> */}
        {/* <BaseCol flex="auto"></BaseCol> */}
        {/* <BaseCol>
              <BaseRow gutter={[8, 8]} justify="end" align="middle"> */}
        <BaseCol>
          <HeaderFullscreen />
        </BaseCol>

        {/* <BaseCol>
          <NotificationsDropdown />
        </BaseCol> */}

        {/* <BaseCol>
          <SettingsDropdown />
        </BaseCol> */}

        <BaseCol>
          <ProfileDropdown />
        </BaseCol>
        {/* </BaseRow>
            </BaseCol> */}
        {/* </BaseRow>
        </S.ProfileColumn> */}
      </BaseRow>

      <BaseRow style={{ marginTop: '0', height: '30px' }}>
        <BaseCol>{breadcrumb}</BaseCol>
      </BaseRow>
      <BaseRow
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 0,
          height: '30px',
          width: '100%',
        }}
      >
        {/* Left side buttons (everything except Close) */}
        <BaseCol>
          <div style={{ display: 'flex', gap: '8px' }}>
            {headerButtons
              .filter((btn) => btn.id !== 'Close')
              .map((btn) => (
                <React.Fragment key={btn.id}>{btn.element}</React.Fragment>
              ))}
          </div>
        </BaseCol>

        {/* Right side Close button */}
        <BaseCol style={{ marginRight: '30px' }}>{headerButtons.find((btn) => btn.id === 'Close')?.element}</BaseCol>
      </BaseRow>
    </>
  );
};
